import LoadFromBackendMenuItem from './components/LoadFromBackendMenuItem.jsx';
import LoadFromBackendMenuItemHandler from './components/LoadFromBackendMenuItemHandler.jsx';
import LoadFromBackendDialog from './components/LoadFromBackendDialog.jsx';
import SaveSpecDialog from './components/SaveSpecDialog.jsx';
import NewSpecMenuItem from './components/NewSpecMenuItem.jsx';
import SaveSpecMenuItem from './components/SaveSpecMenuItem.jsx';
import HealthStatusDialog from './components/HealthStatusDialog.jsx';
import HealthStatusMenuItem from './components/HealthStatusMenuItem.jsx';
import SpecsManagerDialog from './components/SpecsManagerDialog.jsx';
import SpecsManagerMenuItem from './components/SpecsManagerMenuItem.jsx';
import SpecAccessDialog from './components/SpecAccessDialog.jsx';
import ShareLinksDialog from './components/ShareLinksDialog.jsx';
import UrlSpecHandler from './components/UrlSpecHandler.jsx';
import PrimeMenu from './components/PrimeMenu.jsx';
import TopBarFileMenuWrapper from './wrap-components/TopBarFileMenuWrapper.jsx';
import TopBarPagoMenuWrapper from './wrap-components/TopBarPagoMenuWrapper.jsx';
import TopBarEnvironmentIndicatorWrapper from './wrap-components/TopBarEnvironmentIndicatorWrapper.jsx';
import TopBarSaveButtonWrapper from './wrap-components/TopBarSaveButtonWrapper.jsx';
import TopBarPrimeMenuWrapper from './wrap-components/TopBarPrimeMenuWrapper.jsx';
import {
  fetchSpecsList,
  fetchSpecsListStarted,
  fetchSpecsListSuccess,
  fetchSpecsListFailure,
  fetchSpecDetails,
  fetchSpecDetailsStarted,
  fetchSpecDetailsSuccess,
  fetchSpecDetailsFailure,
  loadSpecIntoEditor,
  loadSpecByName,
  saveSpec,
  saveSpecStarted,
  saveSpecSuccess,
  saveSpecFailure,
  newSpec,
  setCurrentSpec,
  clearCurrentSpec,
  updateUrlWithSpecName,
  clearUrlSpec,
  fetchHealthStatus,
  fetchHealthStarted,
  fetchHealthSuccess,
  fetchHealthFailure,
  deleteSpec,
  deleteSpecStarted,
  deleteSpecSuccess,
  deleteSpecFailure,
  saveEndpointSetting,
  saveEndpointSettingStarted,
  saveEndpointSettingSuccess,
  saveEndpointSettingFailure,
  updateUpstreamEnvironment,
  updateUpstreamStarted,
  updateUpstreamSuccess,
  updateUpstreamFailure,
  fetchGlobalConfig,
  fetchGlobalConfigStarted,
  fetchGlobalConfigSuccess,
  fetchGlobalConfigFailure,
  updateGlobalConfig,
  updateGlobalConfigStarted,
  updateGlobalConfigSuccess,
  updateGlobalConfigFailure,
  fetchEnvironments,
  fetchEnvironmentsStarted,
  fetchEnvironmentsSuccess,
  fetchEnvironmentsFailure,
  createEnvironment,
  createEnvironmentStarted,
  createEnvironmentSuccess,
  createEnvironmentFailure,
  deleteEnvironment,
  deleteEnvironmentStarted,
  deleteEnvironmentSuccess,
  deleteEnvironmentFailure,
  fetchEnvironmentDetail,
  fetchEnvironmentDetailStarted,
  fetchEnvironmentDetailSuccess,
  fetchEnvironmentDetailFailure,
  setActiveEnvironment,
  upsertEnvSpecSetting,
  upsertEnvSpecSettingStarted,
  upsertEnvSpecSettingSuccess,
  upsertEnvSpecSettingFailure,
  upsertEnvEndpointSetting,
  upsertEnvEndpointSettingStarted,
  upsertEnvEndpointSettingSuccess,
  upsertEnvEndpointSettingFailure,
  fetchSpecAccess,
  grantSpecAccess,
  revokeSpecAccess,
  setUserDefaultSpec,
  fetchShareLinks,
  createShareLink,
  revokeShareLink,
  fetchSpecCors,
  updateSpecCors,
} from './actions.js';
import reducers, { initialState } from './reducers.js';
import {
  selectBackendBaseUrl,
  selectSpecsList,
  selectSpecsListLoading,
  selectSpecsListError,
  selectSelectedSpec,
  selectSpecDetailsLoading,
  selectSpecDetailsError,
  selectCurrentSpec,
  selectSaveLoading,
  selectSaveError,
  selectIsNewSpec,
  selectHealth,
  selectHealthLoading,
  selectHealthError,
  selectDeleteLoading,
  selectDeleteError,
  selectEndpointSettingSaving,
  selectEndpointSettingSaveError,
  selectLastSavedEndpointSetting,
  selectUpstreamUpdating,
  selectUpstreamUpdateError,
  selectGlobalConfig,
  selectGlobalConfigLoading,
  selectGlobalConfigError,
  selectGlobalConfigUpdating,
  selectGlobalConfigUpdateError,
  selectEnvironments,
  selectEnvironmentsLoading,
  selectEnvironmentsError,
  selectActiveEnvironment,
  selectEnvironmentDetail,
  selectEnvironmentDetailLoading,
  selectCreateEnvironmentLoading,
  selectCreateEnvironmentError,
  selectDeleteEnvironmentLoading,
  selectDeleteEnvironmentError,
  selectEnvSpecSettingUpdating,
  selectEnvSpecSettingError,
  selectEnvEndpointSettingUpdating,
  selectEnvEndpointSettingError,
} from './selectors.js';

const BackendSpecsPlugin = () => ({
  components: {
    LoadFromBackendMenuItem,
    LoadFromBackendMenuItemHandler,
    LoadFromBackendDialog,
    SaveSpecDialog,
    NewSpecMenuItem,
    SaveSpecMenuItem,
    HealthStatusDialog,
    HealthStatusMenuItem,
    SpecsManagerDialog,
    SpecsManagerMenuItem,
    SpecAccessDialog,
    ShareLinksDialog,
    UrlSpecHandler,
    PrimeMenu,
  },
  wrapComponents: {
    TopBarFileMenu: TopBarFileMenuWrapper,
    TopBarPagoMenu: TopBarPagoMenuWrapper,
    TopBarEnvironmentIndicator: TopBarEnvironmentIndicatorWrapper,
    TopBarSaveButton: TopBarSaveButtonWrapper,
    TopBar: TopBarPrimeMenuWrapper,
  },
  statePlugins: {
    backendSpecs: {
      initialState,
      actions: {
        fetchSpecsList,
        fetchSpecsListStarted,
        fetchSpecsListSuccess,
        fetchSpecsListFailure,
        fetchSpecDetails,
        fetchSpecDetailsStarted,
        fetchSpecDetailsSuccess,
        fetchSpecDetailsFailure,
        loadSpecIntoEditor,
        loadSpecByName,
        saveSpec,
        saveSpecStarted,
        saveSpecSuccess,
        saveSpecFailure,
        newSpec,
        setCurrentSpec,
        clearCurrentSpec,
        updateUrlWithSpecName,
        clearUrlSpec,
        fetchHealthStatus,
        fetchHealthStarted,
        fetchHealthSuccess,
        fetchHealthFailure,
        deleteSpec,
        deleteSpecStarted,
        deleteSpecSuccess,
        deleteSpecFailure,
        saveEndpointSetting,
        saveEndpointSettingStarted,
        saveEndpointSettingSuccess,
        saveEndpointSettingFailure,
        updateUpstreamEnvironment,
        updateUpstreamStarted,
        updateUpstreamSuccess,
        updateUpstreamFailure,
        fetchGlobalConfig,
        fetchGlobalConfigStarted,
        fetchGlobalConfigSuccess,
        fetchGlobalConfigFailure,
        updateGlobalConfig,
        updateGlobalConfigStarted,
        updateGlobalConfigSuccess,
        updateGlobalConfigFailure,
        fetchEnvironments,
        fetchEnvironmentsStarted,
        fetchEnvironmentsSuccess,
        fetchEnvironmentsFailure,
        createEnvironment,
        createEnvironmentStarted,
        createEnvironmentSuccess,
        createEnvironmentFailure,
        deleteEnvironment,
        deleteEnvironmentStarted,
        deleteEnvironmentSuccess,
        deleteEnvironmentFailure,
        fetchEnvironmentDetail,
        fetchEnvironmentDetailStarted,
        fetchEnvironmentDetailSuccess,
        fetchEnvironmentDetailFailure,
        setActiveEnvironment,
        upsertEnvSpecSetting,
        upsertEnvSpecSettingStarted,
        upsertEnvSpecSettingSuccess,
        upsertEnvSpecSettingFailure,
        upsertEnvEndpointSetting,
        upsertEnvEndpointSettingStarted,
        upsertEnvEndpointSettingSuccess,
        upsertEnvEndpointSettingFailure,
        fetchSpecAccess,
        grantSpecAccess,
        revokeSpecAccess,
        setUserDefaultSpec,
        fetchShareLinks,
        createShareLink,
        revokeShareLink,
        fetchSpecCors,
        updateSpecCors,
      },
      reducers,
      selectors: {
        selectBackendBaseUrl,
        selectSpecsList,
        selectSpecsListLoading,
        selectSpecsListError,
        selectSelectedSpec,
        selectSpecDetailsLoading,
        selectSpecDetailsError,
        selectCurrentSpec,
        selectSaveLoading,
        selectSaveError,
        selectIsNewSpec,
        selectHealth,
        selectHealthLoading,
        selectHealthError,
        selectDeleteLoading,
        selectDeleteError,
        selectEndpointSettingSaving,
        selectEndpointSettingSaveError,
        selectLastSavedEndpointSetting,
        selectUpstreamUpdating,
        selectUpstreamUpdateError,
        selectGlobalConfig,
        selectGlobalConfigLoading,
        selectGlobalConfigError,
        selectGlobalConfigUpdating,
        selectGlobalConfigUpdateError,
        selectEnvironments,
        selectEnvironmentsLoading,
        selectEnvironmentsError,
        selectActiveEnvironment,
        selectEnvironmentDetail,
        selectEnvironmentDetailLoading,
        selectCreateEnvironmentLoading,
        selectCreateEnvironmentError,
        selectDeleteEnvironmentLoading,
        selectDeleteEnvironmentError,
        selectEnvSpecSettingUpdating,
        selectEnvSpecSettingError,
        selectEnvEndpointSettingUpdating,
        selectEnvEndpointSettingError,
      },
    },
  },
});

export default BackendSpecsPlugin;
